<template>
    <section v-if="pageLoader">
        <div class="page-loader">{{ $t("loading.loading") }}</div>
    </section>
    <section v-else-if="!userIsEmpty('user')" class="guests">
        <div class="section-header guests-section-header section-header-alt">
            <div class="container-mobile">
                <h1 class="heading guests-heading">
                    {{ $t("profile.guests") }}
                </h1>
                <span v-if="isVip && !guestsIsEmpty('guests')" @click="clearGuests" class="guests-clear"
                    :class="{ loader: buttonLoader }">
                    {{ $t("profile.guests") }}
                    {{ $t("threads.clearGuestList") }}
                </span>
            </div>
        </div>
        <div class="info-block guests-info-block container-mobile">
            <div v-if="isVip">
                <div v-if="!guestsIsEmpty('guests')" class="user-list">
                    <div v-for="(guest, index) in guests" class="user-item guests-user-item" :key="index"
                        :ref="'element' + index">
                        <router-link :to="'/profile/' + guest.id" :style="{
                            'background-image': guest.avatar
                                ? 'url(' + guest.avatar + ')'
                                : '',
                        }" class="user-item-avatar" :class="{
    'no-avatar': !guest.avatar,
    online: guest.online,
}"></router-link>
                        <div class="user-item-info">
                            <router-link :to="'/profile/' + guest.id" class="user-item-title">{{ guest.name }}</router-link>
                            <div v-if="guest.city" class="user-item-subtitle">
                                {{ guest.city }}
                            </div>
                            <div class="user-item-bottom">
                                {{ getVerbalDate(guest.time * 1000) }}
                            </div>
                        </div>
                    </div>
                    <div v-if="moreLoader" class="button-loader"></div>
                </div>
                <div v-else>
                    {{ $t("profile.theGuestListEmpty") }}
                </div>
            </div>
            <div v-else class="guests-forbidden">
                <div>
                    {{ $t("threads.sectionVIPStatus") }}
                </div>
                <button @click="$modal.show('vip-buy')" class="button guests-forbidden-button">
                    {{ $t("threads.buyVipStatus") }}
                </button>
            </div>
        </div>
    </section>
    <section v-else class="no-auth">
        {{ $t("auth.noAuth") }}
        <router-link class="link" tag="a" :to="{ name: 'home' }">{{ $t("auth.noAuthLink") }}
        </router-link>
    </section>
</template>

<script>
import { mapGetters } from "vuex";
import { formatDateTime } from "@/mixins/formatDateTime";
import { observeListEnd } from "@/mixins/observeListEnd";

export default {
    name: "Guests",
    props: {
        i18n: Object,
    },
    mixins: [formatDateTime, observeListEnd],
    data() {
        return {
            pageLoader: true,
            buttonLoader: false,
            moreLoader: false,
            moreIndex: 0,
            observer: null,
        };
    },
    computed: {
        ...mapGetters({
            userIsEmpty: "user/isEmpty",
            user: "user/fetchUser",
            guestsIsEmpty: "guests/isEmpty",
            guests: "guests/fetchGuests",
            next: "guests/fetchGuestsNext",
            pageSize: "guests/fetchEventsPageSize",
            init: "init/fetchInit",
            newCount: "guests/fetchGuestsNewCount",
        }),
        isVip() {
            return this.user.vip;
        },
    },
    created() {
        this.getGuests();
        let self = this;
        this.observer = new IntersectionObserver(
            function (entries) {
                if (entries[0].isIntersecting === true) {
                    self.showMore();
                }
            },
            { threshold: [0] }
        );
    },
    methods: {
        getGuests() {
            this.$store
                .dispatch("guests/get")
                .then(() => {
                    this.pageLoader = false;
                    this.updateMoreIndex();
                    this.observeListEnd("element");
                    this.decrementCounter();
                })
                .catch(() => {
                    this.pageLoader = false;
                });
        },
        decrementCounter() {
            if (this.init.counters.guests == 0) {
                return;
            }
            this.$store.dispatch("init/setCounters", {
                counter: "guests",
                increment: true,
                count: -1 * this.newCount,
            });
        },
        updateMoreIndex() {
            this.moreIndex = this.guests.length - 2;
        },
        clearGuests() {
            this.buttonLoader = true;
            this.$store
                .dispatch("guests/clear")
                .then(() => {
                    this.buttonLoader = false;
                    this.observeListEnd("element", false, true);
                })
                .catch(() => {
                    this.buttonLoader = false;
                });
        },
        showMore() {
            if (this.next) {
                this.moreLoader = true;
                this.$store
                    .dispatch("guests/getNext")
                    .then(() => {
                        this.decrementCounter();
                        this.observeListEnd("element", false, true, true);
                        this.moreLoader = false;
                    })
                    .catch(() => {
                        this.moreLoader = false;
                    });
            } else {
                this.observeListEnd("element", false, true);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_user-item";
@import "~@/assets/styles/pages/_guests";
</style>
